import React from 'react';
import { AuthStates, SessionStates, useAuthState, useLogout, useRefresh } from '@vis-auth/react';
import { Button, ButtonGroup, Modal } from '@ver-uds/react';
import { Alert } from '@ver-uds/uswds-react';

export default function SessionTimeout() {
  const { state, sessionState, timeLeft } = useAuthState();
  const logout = useLogout();
  const refresh = useRefresh();
  const showModal = sessionState === SessionStates.warning;
  const timeLeftDate = new Date(timeLeft);

  if (state !== AuthStates.authenticated) {
    return null;
  }
  return (
    <Modal
      id="session-expiring-modal"
      header="Session Expiring"
      open={showModal}
      close={refresh}
      hasDismissButton={false}
    >
      <Modal.Content>
        <Alert status="warning">
          <Alert.Heading>
            Your session will expire in{' '}
            {timeLeftDate.toLocaleString([], {
              minute: '2-digit',
              second: '2-digit',
            })}
          </Alert.Heading>
          <Alert.Text>To keep your session active, press Continue. To end your session, press Sign Out.</Alert.Text>
        </Alert>
      </Modal.Content>
      <Modal.Footer>
        <ButtonGroup>
          <Button type="button" variant="secondary" onClick={logout}>
            Sign Out
          </Button>
          <Button type="button" variant="primary" onClick={refresh}>
            Continue
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
}
